import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getApplications(_x) {
  return _getApplications.apply(this, arguments);
}
function _getApplications() {
  _getApplications = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, _yield$Api$get, data;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          if (!state.applications) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.applications);
        case 1:
          _context.next = 2;
          return Api().get('api/applications');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('applications/setApplications', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getApplications.apply(this, arguments);
}
export function getEdoc(_x2, _x3) {
  return _getEdoc.apply(this, arguments);
}
function _getEdoc() {
  _getEdoc = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, edocId) {
    var state, _yield$Api$post, data;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          state = _ref2.state;
          _context2.next = 1;
          return Api().post('api/edoc/' + edocId);
        case 1:
          _yield$Api$post = _context2.sent;
          data = _yield$Api$post.data;
          return _context2.abrupt("return", data);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getEdoc.apply(this, arguments);
}
export function sendEdoc(_x4, _x5) {
  return _sendEdoc.apply(this, arguments);
}
function _sendEdoc() {
  _sendEdoc = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, edocId) {
    var state;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state = _ref3.state;
          _context3.next = 1;
          return Api().post('api/send-edoc/' + edocId);
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _sendEdoc.apply(this, arguments);
}